/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} What_Are_You_SellingInputs */

const en_what_are_you_selling = /** @type {(inputs: What_Are_You_SellingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What are you selling?`)
};

const es_what_are_you_selling = /** @type {(inputs: What_Are_You_SellingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué estás vendiendo?`)
};

const fr_what_are_you_selling = /** @type {(inputs: What_Are_You_SellingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que vendez-vous ?`)
};

const de_what_are_you_selling = /** @type {(inputs: What_Are_You_SellingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was verkaufst du?`)
};

const ja_what_are_you_selling = /** @type {(inputs: What_Are_You_SellingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`何を販売しますか？`)
};

const zh_what_are_you_selling = /** @type {(inputs: What_Are_You_SellingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您要卖什么？`)
};

const ar_what_are_you_selling = /** @type {(inputs: What_Are_You_SellingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ما الذي تبيعه؟`)
};

const id_what_are_you_selling = /** @type {(inputs: What_Are_You_SellingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apa yang Anda jual?`)
};

const it_what_are_you_selling = /** @type {(inputs: What_Are_You_SellingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cosa stai vendendo?`)
};

const ru_what_are_you_selling = /** @type {(inputs: What_Are_You_SellingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Что вы продаете?`)
};

const pt_what_are_you_selling = /** @type {(inputs: What_Are_You_SellingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que você está vendendo?`)
};

const ko_what_are_you_selling = /** @type {(inputs: What_Are_You_SellingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`무엇을 판매하시나요?`)
};

/**
* | output |
* | --- |
* | "What are you selling?" |
*
* @param {What_Are_You_SellingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const what_are_you_selling = /** @type {((inputs?: What_Are_You_SellingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<What_Are_You_SellingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_what_are_you_selling(inputs)
	if (locale === "es") return es_what_are_you_selling(inputs)
	if (locale === "fr") return fr_what_are_you_selling(inputs)
	if (locale === "de") return de_what_are_you_selling(inputs)
	if (locale === "ja") return ja_what_are_you_selling(inputs)
	if (locale === "zh") return zh_what_are_you_selling(inputs)
	if (locale === "ar") return ar_what_are_you_selling(inputs)
	if (locale === "id") return id_what_are_you_selling(inputs)
	if (locale === "it") return it_what_are_you_selling(inputs)
	if (locale === "ru") return ru_what_are_you_selling(inputs)
	if (locale === "pt") return pt_what_are_you_selling(inputs)
	return ko_what_are_you_selling(inputs)
});